import React, { PropsWithChildren } from "react";
import { TouchableBox } from "../AHTheme/Box";

export type WidgetContainerProps = PropsWithChildren<{
  onPress?: () => void;
  backgroundColor?: string;
}>;

export const AHWidget: React.FC<WidgetContainerProps> = ({
  children,
  backgroundColor,
  onPress,
}) => {
  return (
    <TouchableBox
      disabled={!onPress}
      onPress={onPress}
      style={{
        overflow: "hidden",
        height: "100%",
        width: "100%",
        backgroundColor,
      }}
      color="surface"
    >
      {children}
    </TouchableBox>
  );
};
